<template>
    <div v-html="dcontent.data.content">
   </div>
</template>

<script>

export default {
    data() {
        return {
            startTime : null
        }
    },
    props: {
        dcontent: Object
    },
    beforeMount() {
        let today = new Date().toISOString()
        this.startTime = today.substring(0,10)+ ' ' + today.substring(11,19)
        
    },
    beforeDestroy() {
        // let today = new Date().toISOString()
        // let endTime = today.substring(0,10)+ ' ' + today.substring(11,19)
    }

}
</script>
